import type { Query, QueryOrderV2Args } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { ORDER } from './gql/order';

type QueryDataType = Pick<Query, 'orderV2'>;
type OutgoingDataType = QueryDataType['orderV2'] | undefined;

const onError = getErrorLoggerFunction('orderV2');

export const useOrder = (orderNumber: string) => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { loading, data, error, refetch } = useQuery<QueryDataType, QueryOrderV2Args>(ORDER, {
        variables: {
            orderNumber
        },
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.orderV2);
        }
    }, [data]);

    return {
        order: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
